import React from "react";
import LegalLayout from "../components/LegalLayout";
import { Truck, RotateCcw, ShieldCheck, Clock } from "lucide-react";

const Section = ({ title, children }) => (
  <section className="space-y-3">
    <h2 className="font-display font-bold text-2xl text-slate-900">{title}</h2>
    {children}
  </section>
);

const ShippingPage = () => (
  <LegalLayout title="Spedizioni e Resi" lastUpdate="Febbraio 2026">
    <div className="grid sm:grid-cols-2 gap-4">
      {[
        { Icon: Truck, title: "Spedizione veloce", text: "24-48h dall'ordine" },
        { Icon: ShieldCheck, title: "Tracciamento", text: "Codice di tracking via email" },
        { Icon: RotateCcw, title: "Reso facile", text: "14 giorni dalla consegna" },
        { Icon: Clock, title: "Assistenza", text: "Risposta entro 24h" },
      ].map(({ Icon, title, text }, i) => (
        <div key={i} className="bg-pink-100 border-2 border-slate-900 rounded-2xl p-4 flex items-center gap-3">
          <span className="w-10 h-10 bg-yellow-300 border-2 border-slate-900 rounded-full flex items-center justify-center shrink-0">
            <Icon className="w-5 h-5" />
          </span>
          <div>
            <div className="font-display font-bold">{title}</div>
            <div className="text-sm text-slate-600">{text}</div>
          </div>
        </div>
      ))}
    </div>

    <Section title="Spedizione in Italia">
      <p>
        Gli ordini vengono preparati e spediti entro 24-48 ore lavorative dalla conferma
        del pagamento. La consegna avviene tramite corriere espresso, in genere entro
        2-4 giorni lavorativi dalla spedizione.
      </p>
      <ul className="list-disc pl-6 space-y-1">
        <li>Costo spedizione standard: a partire da € 6,90</li>
        <li>Spedizione <strong>gratuita</strong> per ordini superiori a € 49</li>
        <li>Per le isole minori i tempi possono allungarsi di 1-2 giorni</li>
      </ul>
    </Section>

    <Section title="Spedizione in Europa">
      <p>
        Spediamo nei principali paesi UE. I costi e i tempi di consegna sono calcolati
        automaticamente al checkout in base al peso e al paese di destinazione.
      </p>
    </Section>

    <Section title="Tracciamento ordine">
      <p>
        Una volta spedito l'ordine, riceverai un'email di conferma con il codice di
        tracciamento e il link per monitorare la spedizione in tempo reale. Se non lo
        ricevi entro 48h dalla conferma d'ordine, controlla la cartella spam o
        contattaci.
      </p>
    </Section>

    <Section title="Diritto di recesso e resi">
      <p>
        Hai 14 giorni di tempo dalla ricezione del prodotto per esercitare il diritto di
        recesso, senza dover fornire alcuna motivazione. Per attivare il reso:
      </p>
      <ol className="list-decimal pl-6 space-y-1">
        <li>Invia una email a <a href="mailto:info@nalise.it" className="text-sky-600 underline">info@nalise.it</a> indicando il numero dell'ordine</li>
        <li>Riceverai entro 24h le istruzioni per la restituzione</li>
        <li>Rispedisci il prodotto integro, nella confezione originale e completo di ogni componente</li>
        <li>Una volta ricevuto e verificato il prodotto, procederemo al rimborso entro 14 giorni</li>
      </ol>
      <p>
        Le spese di spedizione per la restituzione sono a carico del cliente, salvo nei
        casi di prodotto difettoso o errore nostro.
      </p>
    </Section>

    <Section title="Prodotti difettosi o danneggiati">
      <p>
        Se ricevi un prodotto difettoso o danneggiato durante il trasporto, contattaci
        entro 7 giorni dalla ricezione allegando alcune foto del prodotto e
        dell'imballaggio. Provvederemo immediatamente alla sostituzione o al rimborso,
        senza spese per te.
      </p>
    </Section>

    <Section title="Garanzia legale">
      <p>
        Tutti i prodotti sono coperti dalla garanzia legale di conformità di 24 mesi
        prevista dal Codice del Consumo.
      </p>
    </Section>

    <p className="text-sm text-slate-500 pt-6 border-t">
      Tariffe e tempi sono indicativi e potrebbero variare. I costi esatti vengono
      sempre mostrati prima della conferma dell'ordine.
    </p>
  </LegalLayout>
);

export default ShippingPage;
